import { datadogLogs } from "@datadog/browser-logs";

const XHR_ERROR_PATTERN = /xhr error/i;
const FETCH_ERROR_POST_PATTERN = /fetch error post/i;

// Where the Datadog SDK persists its session + anonymous visitor id.
const DATADOG_SESSION_KEYS = ["_dd_s_v2", "_dd_s"];

// Starts with tracking consent withheld: the SDK stays dormant (no session
// cookie, no network) until datadogEnable() grants it. Manual logger calls made
// in the meantime are held in memory and only sent if consent is granted.
export const datadogInit = async function () {
  if (process.env.NEXT_PUBLIC_DATADOG) {
    datadogLogs.init({
      clientToken: process.env.NEXT_PUBLIC_DATADOG,
      site: "datadoghq.com",
      forwardErrorsToLogs: true,
      sessionSampleRate: 100,
      service: "marketing-monorepo",
      env: process.env.NEXT_PUBLIC_ENVIRONMENT,
      version: process.env.NEXT_PUBLIC_VERCEL_GIT_COMMIT_SHA,
      trackingConsent: "not-granted",
      beforeSend: (log) => {
        if (
          XHR_ERROR_PATTERN.test(log.message) ||
          FETCH_ERROR_POST_PATTERN.test(log.message)
        ) {
          return false;
        }
        return true;
      },
    });
  }
};

// Call once consent for Datadog's OneTrust category is granted.
export function datadogEnable(): void {
  datadogLogs.setTrackingConsent("granted");
}

// Call when consent for Datadog's OneTrust category is denied or withdrawn.
// The SDK expires its session and drops the anonymous id; the purge also
// removes a session cookie left behind by an earlier page view.
export function datadogDisable(): void {
  datadogLogs.setTrackingConsent("not-granted");
  purgeDatadogSession();
}

function purgeDatadogSession(): void {
  if (typeof window === "undefined" || typeof document === "undefined") return;

  const hostParts = window.location.hostname.split(".");
  const domains = [
    undefined,
    ...hostParts.map((_, index) => `.${hostParts.slice(index).join(".")}`),
  ];
  const expired = "=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/";

  for (const name of DATADOG_SESSION_KEYS) {
    for (const domain of domains) {
      document.cookie = domain
        ? `${name}${expired};domain=${domain}`
        : `${name}${expired}`;
    }
  }

  try {
    for (const name of DATADOG_SESSION_KEYS) {
      window.localStorage.removeItem(name);
    }
  } catch {
    // localStorage can throw when storage is blocked; nothing to purge then.
  }
}
